<template>
  <div class="centered-container">
    <div class="form">
      <div class="title">
        <div>ログイン</div>
      </div>

      <div v-if="errorMessage != null" class="red--text">{{ errorMessage }}</div>
      <form v-on:submit.prevent="login()">
        <v-text-field label="ID" v-model="user" :disabled="progress"></v-text-field>
        <v-text-field label="Password" v-model="password" type="password" :disabled="progress"></v-text-field>
        <div>
          <router-link to="/pp" replace>プライバシーポリシー</router-link>
          <div style="color:gray; margin:.5em 0;">ログインすると、プライバシーポリシーに同意したものとみなします。</div>
        </div>
        <div class="text-xs-right">
          <v-btn color="info" type="submit" :disabled="progress">ログイン</v-btn>
        </div>
        <LoadingOverlay v-if="progress"/>
      </form>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
import api from '../lib/api.js'
import {getLoginMessage, setAuthToken} from '@/lib/common'
import LoadingOverlay from '@/components/LoadingOverlay'

export default {
  name: 'Login',
  components: {LoadingOverlay},
  created () {
    // this.errorMessage = getLoginMessage()
  },
  data () {
    return {
      user: '',
      password: '',
      progress: false,
      errorMessage: getLoginMessage()
    }
  },
  methods: {
    login () {
      this.progress = true
      console.log('hoge')
      // alert('hoge')
      api.login(this.user, this.password).then((response) => {
        this.progress = false
        setAuthToken(response.data.token, response.data.group)
        console.log(`POST成功 ${response}`)
        this.$router.replace('/')
      }).catch((error) => {
        this.progress = false
        if (error.response != null) {
          switch (error.response.status) {
            case 401:
              this.errorMessage = '認証エラー'
              break
            default:
              this.errorMessage = `エラー ${error.response.status}`
              break
          }
        } else {
          this.errorMessage = error.message
        }
        console.log(`POST失敗 ${error}`)
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .centered-container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    height: 100%;

    .title {
      text-align: center;
      margin-bottom: 30px;

      img {
        margin-bottom: 16px;
        max-width: 80px;
      }
    }

    .background {
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      z-index: 0;
    }

    .form {
      padding: 40px;
      margin-bottom: 8px;
    }

    .error {
      /*color: red*/
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue